import { connect } from "react-redux";
import {
  changeCalculNameForm,
  changeProjectName,
  changeSimulationMode,
} from "../actions";
import FdesInformations from "../components/FdesInformations";

export default connect(
  (state) => ({
    calculName: state.fdes.calculName,
    projectName: state.fdes.projectName,
    simulationMode: state.fdes.simulationMode,
  }),
  (dispatch) => ({
    onChangeCalculName: (value) => {
      dispatch(changeCalculNameForm(value));
    },
    onChangeProjectName: (value) => {
      dispatch(changeProjectName(value));
    },
    onChangeSimulationMode: (value) => {
      dispatch(changeSimulationMode(value));
    },
  })
)(FdesInformations);
